import React from "react";
import { Toaster } from "react-hot-toast";

const HotToast = () => {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        style: {
          padding: "16px",
          width: "350px",
          borderRadius: "2px",
          background: "#333",
          color: "#fff",
          boxShadow: "1px 6px 20px black",
          fontSize: "18px",
        },

        success: {
          duration: 10000,
          style: {
            borderRight: "6px solid lightgreen",
          },
        },

        error: {
          duration: 10000,
          style: { borderRight: "6px solid red" },
        },
      }}
    />
  );
};

export default HotToast;
